"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hexWithTransparency = exports.percentToHex = void 0;
exports.percentToHex = function (percent) {
    var intValue = Math.round(percent * 255);
    var hexValue = intValue.toString(16);
    return hexValue.padStart(2, '0').toUpperCase();
};
exports.hexWithTransparency = function (hexCode, percent) {
    return "" + hexCode + exports.percentToHex(percent);
};
